import { useMemo } from 'react'

const hasWebGL = () => {
  try {
    if (window.Cesium?.FeatureDetection?.supportsWebGL?.()) return true
    const canvas = document.createElement('canvas')
    const gl2 = canvas.getContext('webgl2', {
      failIfMajorPerformanceCaveat: true
    })
    const gl1 = gl2 || canvas.getContext('webgl', { failIfMajorPerformanceCaveat: true })
    return !!gl1
  } catch {
    return false
  }
}

export default function useMapEligibility() {
  return useMemo(() => {
    const missing = []
    const hints = []

    // 1) WebGL / HW accel
    if (!hasWebGL()) {
      missing.push('WebGL / aceleración por hardware')
      hints.push(
        'Activa la aceleración por hardware del navegador y vuelve a abrir la página.',
        "En Chrome: Ajustes → Sistema → activar 'Usar aceleración por hardware'."
      )
    }

    // 2) Cesium ion token (used by terrain/imagery)
    if (!process.env.REACT_APP_CESIUM_ION_TOKEN) {
      missing.push('Token de Cesium ion (REACT_APP_CESIUM_ION_TOKEN)')
      hints.push('Define REACT_APP_CESIUM_ION_TOKEN en el build o .env.*')
    }

    // 4) HTTPS hint (use window.location instead of global location)
    const { protocol, hostname } =
      typeof window !== 'undefined' && window.location ? window.location : { protocol: '', hostname: 'localhost' }

    if (protocol !== 'https:' && hostname !== 'localhost') {
      hints.push('Usa HTTPS para obtener el mejor soporte de WebGL.')
    }

    return { ok: missing.length === 0, missing, hints }
  }, [])
}
